// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hDxg","image":"Header_image__3yBiu","name":"Header_name__1YqYs","info":"Header_info__1Xvt7","infoRow":"Header_infoRow__zFNA8"};